<template>
  <section class="video">
    <div class="video__overlay" :class="{ 'video__overlay-active': isVideoPlaying }">
      <img format="webp" :src="videoThumbnail" alt="Hour" quality="100" sizes="xs:100vw lg:1000px" />
      <div class="btn-play" @click="playVideo">
        <svg
          id="Capa_1"
          fill="#000000"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 60 60"
          xml:space="preserve"
        >
          <g>
            <path
              d="M45.563,29.174l-22-15c-0.307-0.208-0.703-0.231-1.031-0.058C22.205,14.289,22,14.629,22,15v30
		c0,0.371,0.205,0.711,0.533,0.884C22.679,45.962,22.84,46,23,46c0.197,0,0.394-0.059,0.563-0.174l22-15
		C45.836,30.64,46,30.331,46,30S45.836,29.36,45.563,29.174z M24,43.107V16.893L43.225,30L24,43.107z"
            />
          </g>
        </svg>
      </div>
    </div>
    <div class="video__player">
      <video ref="video" preload="none" controls :src="videoUrl" />
    </div>
  </section>
</template>

<script setup lang="ts">
const isVideoPlaying = ref(false)
const video = ref<HTMLVideoElement | null>(null)
const { locale } = useI18n()

defineProps<{
  videoUrl: string
  videoThumbnail: string
}>()

const playVideo = () => {
  if (video.value) {
    video.value.play()
  }
  isVideoPlaying.value = true
}
</script>

<style lang="scss" scoped>
.video {
  position: relative;
  display: flex;
  justify-content: center;
  height: 600px;
  width: 100%;
}

.video__overlay {
  position: absolute;
  z-index: 1;

  img {
    height: 550px;
    width: 950px;
    object-fit: cover;
  }

  p {
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 25px;
    color: #ffb500;
    width: 600px;
    text-align: center;
  }

  .btn-play {
    transform: translate(-50%, -50%);
    position: absolute;
    background-color: $color-secondary;
    width: 100px;
    height: 100px;
    border-radius: 50px;
    top: 45%;
    left: 50%;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.1s ease-out;

    svg {
      transition: all 0.1s ease-out;
      fill: $color-primary;
      width: 100%;
      height: 100%;
    }
  }

  .btn-play:hover {
    background-color: $color-primary;
    svg {
      fill: $color-secondary;
    }
  }
}

.video__overlay-active {
  animation: slidein 1s ease-out;
  animation-fill-mode: both;
}

@keyframes slidein {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    visibility: hidden;
    transform: scale(0.9);
  }
}

.video__player {
  z-index: 0;
  position: absolute;
  video {
    margin-top: 30px;
    height: 500px;
    width: 900px;
  }
}

@media screen and (max-width: $mobile) {
  .video {
    height: 280px;
  }
  .video__overlay {
    overflow: hidden;
    img {
      width: 100vw;
      height: 230px;
      transform: scale(1.1);
    }
    p {
      font-size: 20px;
      padding: 20px;
      width: 100vw;
    }
    .btn-play {
      top: 40%;
      width: 50px;
      height: 50px;
    }
  }

  .video__player {
    video {
      width: 100vw;
      height: 210px;
      margin-top: 10px;
    }
  }
}
</style>
